// Importar Vuetify y estilos
import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// Configuración de los temas
const vuetify = createVuetify({
    components,
    directives,
    icons: {
      defaultSet: 'mdi', // Configuración de íconos
    },
    theme: {
      themes: {
        light: {
          primary: '#FFC107',   // Amarillo
          secondary: '#424242', // Gris
          accent: '#FFEB3B',    // Amarillo claro
          background: '#F5F5F5',// Fondo gris claro
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        },
      },
      options: {
        customProperties: true, // Permite usar variables CSS personalizadas
      },
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',  // O 'Inter', dependiendo de tu preferencia
    },
  });
  
  export default vuetify;